// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"407":"9552aab6","933":"c521fdf5"}[chunkId] + ".css";
};